import axios from 'axios';
// import { SubmissionError } from 'redux-form';

import { handleErrors, serialize } from 'utils/api';
import { API_CONFIG } from 'constants/config';
import {
  apiCreateSequenceContacts,
  apiMarkAsFinishedSeqContact,
  apiUnmarkAsFinishedSeqContact,
  apiBulkMarkAsFinishedSeqContacts,
  apiBulkUnmarkAsFinishedSeqContacts,
} from 'constants/apiRouting';
import { createActionType } from 'utils/redux';
import {
  MOVE_BULK_SEQUENCE_CONTACT,
  REMOVE_FROM_CAMPAIGN,
  REMOVE_BULK_FROM_CAMPAIGN,
  DESTROY_SEQUENCE_CONTACTS,
  DESTROY_SEQUENCE_CONTACT,
  GET_SEQUENCE_CONTACTS,
  MARK_AS_FINISHED,
  UNMARK_AS_FINISHED,
  BULK_MARK_AS_FINISHED,
  BULK_UNMARK_AS_FINISHED,
} from 'constants/analytics';
import { analyticsTrack } from '../../utils/analytics';

// object
export const CREATE_SEQUENCE_CONTACTS = createActionType('CREATE_SEQUENCE_CONTACTS');
export const UPDATE_SEQUENCE_CONTACT_PENDING = 'UPDATE_SEQUENCE_CONTACT_PENDING';
export const UPDATE_SEQUENCE_CONTACT_FAIL = 'UPDATE_SEQUENCE_CONTACT_FAIL';
export const UPDATE_SEQUENCE_CONTACT_SUCCESS = 'UPDATE_SEQUENCE_CONTACT_SUCCESS';
export const DESTROY_SEQUENCE_CONTACT_PENDING = 'DESTROY_SEQUENCE_CONTACT_PENDING';
export const DESTROY_SEQUENCE_CONTACT_FAIL = 'DESTROY_SEQUENCE_CONTACT_FAIL';
export const DESTROY_SEQUENCE_CONTACT_SUCCESS = 'DESTROY_SEQUENCE_CONTACT_SUCCESS';
// objects
export const GET_SEQUENCE_CONTACTS_PENDING = 'GET_SEQUENCE_CONTACTS_PENDING';
export const GET_SEQUENCE_CONTACTS_FAIL = 'GET_SEQUENCE_CONTACTS_FAIL';
export const GET_SEQUENCE_CONTACTS_SUCCESS = 'GET_SEQUENCE_CONTACTS_SUCCESS';
export const UPDATE_BULK_SEQUENCE_CONTACT_PENDING = 'UPDATE_BULK_SEQUENCE_CONTACT_PENDING';
export const UPDATE_BULK_SEQUENCE_CONTACT_FAIL = 'UPDATE_BULK_SEQUENCE_CONTACT_FAIL';
export const UPDATE_BULK_SEQUENCE_CONTACT_SUCCESS = 'UPDATE_BULK_SEQUENCE_CONTACT_SUCCESS';

export const GET_SEQUENCE_PENDING_CONTACTS_PENDING = 'GET_SEQUENCE_PENDING_CONTACTS_PENDING';
export const GET_SEQUENCE_PENDING_CONTACTS_FAIL = 'GET_SEQUENCE_PENDING_CONTACTS_FAIL';
export const GET_SEQUENCE_PENDING_CONTACTS_SUCCESS = 'GET_SEQUENCE_PENDING_CONTACTS_SUCCESS';

export const MARK_AS_FINISHED_SEQUENCE_CONTACT = createActionType('MARK_AS_FINISHED_SEQUENCE_CONTACT');
export const MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT = createActionType('MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT');
export const UNMARK_AS_FINISHED_SEQUENCE_CONTACT = createActionType('UNMARK_AS_FINISHED_SEQUENCE_CONTACT');
export const UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT = createActionType('UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT');


export const updateSequenceContact = (
  seqContactId,
  params = {
    sequence: null,
  },
) => async (dispatch) => {
  dispatch({
    type: UPDATE_SEQUENCE_CONTACT_PENDING,
    payload: params,
  });
  try {
    const response = await axios.patch(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${seqContactId}/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_SEQUENCE_CONTACT_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const updateBulkSequenceContact = (data = [], params = {}) => async (dispatch) => {
  analyticsTrack(MOVE_BULK_SEQUENCE_CONTACT, params, true);
  dispatch({
    type: UPDATE_BULK_SEQUENCE_CONTACT_PENDING,
  });
  try {
    await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/bulk/`,
      data,
      { withCredentials: true, params },
    );
    dispatch({
      type: UPDATE_BULK_SEQUENCE_CONTACT_SUCCESS,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const markAsFinishedSequenceContact = (seqContactId, params = []) => async (dispatch) => {
  // eslint-disable-next-line no-undef
  analytics.track(MARK_AS_FINISHED, { sequenceContact: seqContactId });
  await dispatch({
    type: MARK_AS_FINISHED_SEQUENCE_CONTACT.name,
    payload: axios.put(
      apiMarkAsFinishedSeqContact(seqContactId),
      params, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};

export const unmarkAsFinishedSequenceContact = (seqContactId, params = []) => async (dispatch) => {
  // eslint-disable-next-line no-undef
  analytics.track(UNMARK_AS_FINISHED, { sequenceContact: seqContactId });
  await dispatch({
    type: UNMARK_AS_FINISHED_SEQUENCE_CONTACT.name,
    payload: axios.put(
      apiUnmarkAsFinishedSeqContact(seqContactId),
      params, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};

export const markBulkAsFinishedSequenceContact = seqContactIds => async (dispatch) => {
  // eslint-disable-next-line no-undef
  analytics.track(BULK_MARK_AS_FINISHED, { sequenceContacts: seqContactIds });
  await dispatch({
    type: MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.name,
    payload: axios.put(
      apiBulkMarkAsFinishedSeqContacts(),
      seqContactIds, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};

export const unmarkBulkAsFinishedSequenceContact = seqContactIds => async (dispatch) => {
  // eslint-disable-next-line no-undef
  analytics.track(BULK_UNMARK_AS_FINISHED, { sequenceContacts: seqContactIds });
  await dispatch({
    type: UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.name,
    payload: axios.put(
      apiBulkUnmarkAsFinishedSeqContacts(),
      seqContactIds, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};

export const removeFromCampaignSequenceContact = seqContactId => async (dispatch) => {
  analyticsTrack(REMOVE_FROM_CAMPAIGN, { sequenceContact: seqContactId }, true);
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${seqContactId}/remove-from-campaign/`,
      { withCredentials: true },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const removeBulkFromCampaignSequenceContact = (seqContactIds, params = {}) => async (dispatch) => {
  analyticsTrack(REMOVE_BULK_FROM_CAMPAIGN, { sequenceContacts: seqContactIds }, true);
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/remove-from-campaign/`,
      { withCredentials: true, data: seqContactIds, params },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const destroyBulkSequenceContact = (seqContactIds, params = {}) => async (dispatch) => {
  analyticsTrack(DESTROY_SEQUENCE_CONTACTS, { sequenceContacts: seqContactIds }, true);
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/bulk/`,
      { withCredentials: true, data: seqContactIds, params },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const destroySequenceContact = seqContactId => async (dispatch) => {
  analyticsTrack(DESTROY_SEQUENCE_CONTACT, {
    sequenceContact: seqContactId,
  }, true);
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequence-contacts/${seqContactId}/`,
      { withCredentials: true },
    );
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getSequenceContacts = (
  sequenceId,
  params = {
    search: null,
    statuses: null,
    page: null,
    active: null,
    detail_page: null,
  },
  seamless = false,
  actionType = 'GET_SEQUENCE_CONTACTS',
) => async (dispatch) => {
  analyticsTrack(GET_SEQUENCE_CONTACTS, params, true);

  let paramsCopy = { ...params };
  paramsCopy = serialize(paramsCopy, true, true);
  const urlEncodedParams = new URLSearchParams(paramsCopy);
  dispatch({
    type: `${actionType}_PENDING`,
    payload: seamless ? { ...urlEncodedParams, loading: false, loaded: true } : params,
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequences/${sequenceId}/contacts/`,
      { withCredentials: true, params: urlEncodedParams },
    );
    dispatch({
      type: `${actionType}_SUCCESS`,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: `${actionType}_FAIL`,
      payload: {},
    });
    handleErrors(error, dispatch);
  }
};

export const getPendingSequenceContacts = (sequenceId, params = {}) => getSequenceContacts(sequenceId, {
  ...params,
  active: false,
}, false, 'GET_SEQUENCE_PENDING_CONTACTS');

export const createSequenceContacts = (data = []) => async (dispatch) => {
  await dispatch({
    type: CREATE_SEQUENCE_CONTACTS.name,
    payload: axios.post(
      apiCreateSequenceContacts(),
      data, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};
